module.exports = __webpack_public_path__ + "img/558-42dfb3.png";